module.exports = __webpack_public_path__ + "static/img/brand-fourth-5.3788116e.png";